import React from 'react';
import { KibSnackbarManager, KibSnackbar } from '@chewy/kib-messaging-react';

const VetFailureSnackbar = ({
  visible,
  setVisibility,
  message,
}: {
  visible: boolean;
  setVisibility: (arg0: boolean) => void;
  message: string;
}) => (
  <KibSnackbarManager visible={visible} onClose={() => setVisibility(false)}>
    <KibSnackbar>{message}</KibSnackbar>
  </KibSnackbarManager>
);

export default VetFailureSnackbar;
